import { CanvasHTMLAttributes, FC, JSX } from 'react';

import { Form } from 'antd';
import ReactSignatureCanvas from 'react-signature-canvas';

type TDebtsSignatureCanvasProps = {
	sigRef: React.RefObject<ReactSignatureCanvas>;
	canvasProps: CanvasHTMLAttributes<HTMLCanvasElement>;
	handleSaveSignature?: () => void;
};

export const DebtsSignatureCanvas: FC<TDebtsSignatureCanvasProps> = ({
	sigRef,
	canvasProps,
	handleSaveSignature,
}): JSX.Element => {
	return (
		<Form.Item name={['borrowerSignature', 'signature']}>
			<ReactSignatureCanvas
				ref={sigRef}
				canvasProps={{
					style: { borderRadius: 10, background: 'transparent' },
					...canvasProps,
				}}
				penColor="black"
				onEnd={() => {
					handleSaveSignature?.();
				}}
			/>
		</Form.Item>
	);
};
